@if (loading || sites.length > 0) {
  <div class="p-grid">
    <div class="p-col-12">
      <label>Existing Locations</label>
      @if (loading) {
        <div class="normalized-address-loading" aria-live="polite">
          <span class="pi pi-spin pi-spinner" aria-hidden="true"></span> Checking for existing locations...
        </div>
      }
      @if (!loading && sites.length > 0) {
        <fieldset class="radio-option-list">
          @if (!readonly) {
            <legend class="p-sr-only">Select an existing location</legend>
          }
          @for (site of sites; track site; let i = $index) {
            <div
              class="radio-option"
              [class.radio-option--disabled]="readonly"
              (click)="selectSite(site)"
              [attr.role]="!readonly ? 'button' : null"
              [attr.aria-label]="(!readonly ? 'Select duplicate site: ' : 'Duplicate site: ') + site.partySiteName"
              >
              @if (!readonly) {
                <p-radioButton
                  name="selectedDuplicateSite"
                  [value]="site"
                  [(ngModel)]="selectedSite"
                  [inputId]="'duplicateSite' + i"
                ></p-radioButton>
              }
              <label [for]="!readonly ? 'duplicateSite' + i : null" class="duplicate-site-details">
                <span class="duplicate-site-name">
                  {{ site.partySiteName }}
                  @if (site.chepGlobalLocationId) {
                    - {{ site.chepGlobalLocationId }}
                  }
                </span>
                <span class="duplicate-site-address">{{ site.address1 }}, {{ site.city }}, {{ site.state }} {{ site.postalCode }}</span>
              </label>
            </div>
          }
        </fieldset>
      }
    </div>
  </div>
}
